import { useEffect } from 'react';
import { OnboardingGuideRegister, useAuthentication } from '@ecosystem/newron-client-lib';
import { LeaderboardSlide } from '../leaderboard-slide/LeaderboardSlide';
import { PerformanceInsightsSlide } from '../performance-insights-slide/PerformanceInsightsSlide';
import { PriceTrackingSlide } from '../price-tracking-slide/PriceTrackingSlide';
import { getSubscriptionWithProductType } from '@utils/SubsciptionsUtils';
import { ProductType } from '@pages/product-analyzer/Product';
import { getRetailSubscription } from '@services/opa/Opa.service';

export const UseRegisterSlides = () => {
  const { isAuthenticated } = useAuthentication();

  useEffect(() => {
    (async () => {
      if (!isAuthenticated) {
        return;
      } else {
        //Call persona api to get PerformanceAnalyzer subscription
        const subscriptions = await getRetailSubscription();
        const performanceAnalyzerSubscription = getSubscriptionWithProductType(
          subscriptions,
          ProductType.PerformanceAnalyzer,
        );

        performanceAnalyzerSubscription?.result?.restrictions.length &&
          OnboardingGuideRegister?.getInstance().register({
            domain: 'retail_insights',
            component: [PerformanceInsightsSlide, LeaderboardSlide, PriceTrackingSlide],
            order: 400,
          });
      }
    })();
  }, [isAuthenticated]);
};
